export default __webpack_public_path__ + "static/media/finger_positions_456_mobile.ce2876fe.png";